module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (_vm.getStyle)
  }, [_c('button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:tooltip",
      value: (_vm.t(_vm.getTitle)),
      expression: "t(getTitle)",
      arg: "tooltip"
    }],
    staticClass: "btn btn-sm btn-confirm button-component",
    class: !_vm.getActive ? 'mark-disabled' : '',
    style: ({
      'background-color': _vm.getBackgroundColor
    }),
    attrs: {
      "disabled": !_vm.getActive
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onClick($event)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.t(_vm.getName)) + "\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6664364e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/grid/ActionButtonComponent.vue
// module id = 1313
// module chunks = 2